/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const EyeClosedIcon = createIcon(
  '0 0 20 20',
  <path d="M10 9.636c2.684 0 5.134-1.307 7.075-3.636l1.49 1.291q-.616.739-1.3 1.367L19 10.428l-1.382 1.409L15.7 9.882c-.716.471-1.473.856-2.265 1.143l.89 2.22-1.81.755-.996-2.485a10 10 0 0 1-3.04 0L7.483 14l-1.809-.755.89-2.22A11 11 0 0 1 4.3 9.882l-1.917 1.955L1 10.427l1.735-1.769q-.684-.628-1.3-1.367L2.925 6C4.865 8.33 7.315 9.636 10 9.636" />,
);
